import { Theme } from "@mui/material/styles";
import { TypographyOptions } from "@mui/material/styles/createTypography";

const Typography = (theme: Theme, borderRadius: number): TypographyOptions => ({
  h6: {
    color: theme.palette.grey[600],
    fontSize: "0.75rem",
    fontFamily: "Lato400",
  },
  h5: {
    fontSize: "0.875rem",
    color: theme.palette.grey[600],
    fontFamily: "Lato400",
  },
  h4: {
    fontSize: "1rem",
    color: theme.palette.grey[600],
    fontWeight: 600,
    fontFamily: "Lato400",
  },
  h3: {
    fontSize: "20px",
    color: theme.palette.grey[600],
    fontFamily: "Lato400",
  },
  h2: {
    fontFamily: "Lato700",
    fontSize: "23px",
    color: theme.palette.grey[600],
  },
  h1: {
    fontSize: "26px",
    color: theme.palette.grey[600],
    fontFamily: "Lato700",
  },
  subtitle1: {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: theme.palette.text.dark,
    fontFamily: "Roboto",
  },
  subtitle2: {
    fontSize: "0.75rem",
    fontWeight: 400,
    color: theme.palette.text.secondary,
    fontFamily: "Roboto",
  },
  caption: {
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
    fontWeight: 400,
    fontFamily: "Roboto",
  },
  body1: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "1.334em",
    fontFamily: "Roboto",
  },
  body2: {
    fontSize: "16px",
    letterSpacing: "0em",
    fontWeight: 400,
    lineHeight: "16px",
    fontFamily: "Roboto",
    color: theme.palette.text.primary,
  },
  button: {
    textTransform: "capitalize",
    fontFamily: "Roboto",
  },
  customInput: {
    marginTop: 1,
    marginBottom: 1,
    "& > label": {
      top: 23,
      left: 0,
      color: theme.palette.grey[500],
      '&[data-shrink="false"]': {
        top: 5,
      },
    },
    "& > div > input": {
      padding: "30.5px 14px 11.5px !important",
    },
    "& legend": {
      display: "none",
    },
    "& fieldset": {
      top: 0,
    },
  },
  mainContent: {
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.dark[800]
        : theme.palette.grey[100],
    width: "100%",
    minHeight: "calc(100vh - 88px)",
    flexGrow: 1,
    padding: "20px",
    marginTop: "88px",
    marginRight: "20px",
    borderRadius: `${borderRadius}px`,
    fontFamily: "Roboto",
  },
  menuCaption: {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: theme.palette.grey[600],
    padding: "6px",
    textTransform: "capitalize",
    marginTop: "10px",
    fontFamily: "Roboto",
  },
  subMenuCaption: {
    fontSize: "0.6875rem",
    fontWeight: 500,
    color: theme.palette.text.secondary,
    textTransform: "capitalize",
    fontFamily: "Roboto",
  },
  commonAvatar: {
    cursor: "pointer",
    borderRadius: "8px",
    fontFamily: "Roboto",
  },
  smallAvatar: {
    width: "22px",
    height: "22px",
    fontSize: "1rem",
    fontFamily: "Roboto",
  },
  mediumAvatar: {
    width: "34px",
    height: "34px",
    fontSize: "1.2rem",
    fontFamily: "Roboto",
  },
  largeAvatar: {
    width: "44px",
    height: "44px",
    fontSize: "1.5rem",
    fontFamily: "Roboto",
  },
});

export default Typography;
